module.exports = __webpack_public_path__ + "img/sld_mfm_ic_1_t1_dark.57406565.svg";